// Dashboard.tsx
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Card } from 'primereact/card';
import { Chart } from 'primereact/chart';
import { ProgressBar } from 'primereact/progressbar';
import DashboardCard from './components/DashoardCard';
import { PiUsersThreeBold } from 'react-icons/pi';
import { Message } from 'primereact/message';
import { dashboardCSS } from './Dashboard.css';
import CustomChips from './components/CustomChips';
import { DinamycTable } from './components/DinamycTable';
import { DinamycTableCalendar } from './components/DinamycTableCalendar';
import SubHeaderRowGroupDemo from './components/DinamycTableCalendarCopy';
import { AuthContext } from '../../../Context/AuthContext';
import axios from 'axios';
import { url } from '../../../env';
import { Loader } from '../../../Components';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import CreditScoreDoughnut from './components/ScoreChart';





// Cache para almacenar los datos del buró por usuario

const getAllData = async (toast, id, buroDataCache) => {
  // Crear clave única para el cache
  const cacheKey = `buro_${id}`;

  // Verificar si ya existe en el cache
  if (buroDataCache.current[cacheKey]) {
    /*  console.log(`📦 Datos del buró encontrados en cache para usuario ${id}`); */
    return buroDataCache.current[cacheKey];
  }

  /* console.log(`🔄 Haciendo petición del buró para usuario ${id} - No encontrado en cache`); */

  return axios.get(`${url}/getReportBuro/${id}`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    }
  })
    .then((response) => {
      // Guardar en cache
      buroDataCache.current[cacheKey] = response.data;
      /* console.log(`💾 Datos del buró guardados en cache para usuario ${id}`); */

      toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Datos obtenidos correctamente', life: 3000 });
      return response.data;
    })
    .catch((error) => {
      console.error("Error al obtener datos:", error);
      toast.current.show({ severity: 'error', summary: 'Error', detail: 'Error al obtener datos', life: 3000 });
      // throw error;
    });
};

const fetchDatausersFun = async (toast) => {
  // Simulación de una llamada a la API para obtener datos
  return axios.get(`${url}/getUsersReport`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    }
  })
    .then((response) => {
      toast?.current?.show({ severity: 'success', summary: 'Éxito', detail: 'Datos obtenidos correctamente', life: 3000 });
      return response.data;
    })
    .catch((error) => {
      console.error("Error al obtener datos:", error);
      toast?.current?.show({ severity: 'error', summary: 'Error', detail: 'Error al obtener datos', life: 3000 });
      // throw error;
    });
};

const SelectedPersonComponent = ({ selectedPerson, setSelectedPerson, people, toast }) => {
  const handleChange = (e) => {
    const id = e.value.id;
    setSelectedPerson(e.value);
  };


  return (
    <Card className="select-user-container" style={{
      margin: '2rem auto',
      maxWidth: '600px',
      borderRadius: '15px',
      padding: '1rem'
    }}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1rem'
      }}>
        <h3 style={{
          color: '#34b9e0',
          fontSize: 'calc(1rem + 0.5vw)',
          marginBottom: '1.5rem',
          textAlign: 'center'
        }}>Selecciona una persona para ver el reporte:</h3>
        <Dropdown
          value={selectedPerson}
          options={people}
          onChange={(e) => handleChange(e)}
          optionLabel="name"
          placeholder="Selecciona una persona"
          className="Dropdown Dropdown-user"
          editable
          style={{
            minWidth: '400px',
            fontSize: '14px',
          }}
          itemTemplate={(option) => (
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              fontSize: '14px',
              lineHeight: '1',
            }}>
              <span style={{ fontWeight: 'bold' }}>{option.name} - {option.tipo_persona == "PF" ? "Persona Física" : "Persona Moral"}</span>
              <span style={{
                fontSize: '0.85rem',
                color: '#666',
                marginTop: '0.5rem'
              }}>
                {option.fecha_generacion ? new Date(option.fecha_generacion).toLocaleDateString('es-MX') : 'Sin fecha'}
              </span>
            </div>
          )}
          valueTemplate={(option) => {
            if (option) {
              return (
                <div style={{ fontSize: '16px' }}>
                  <span>{option.name}</span>
                  <span style={{
                    fontSize: '14px',
                    color: '#666',
                    marginLeft: '0.5rem'
                  }}>
                    ({option.tipo_persona == "PF" ? "PF" : "PM"})
                  </span>
                </div>
              );
            }
            return "Selecciona una persona";
          }}
        />
        <div className="shadowCard" style={{ marginTop: '1rem' }}></div>
      </div>
    </Card>
  );
};

// Nuevo componente para PF (copia la lógica actual)
const DashboardPF = ({ dataBuro, selectedPerson, setShowUserSelector, people, toast, data }) => (
  <>
    {/* Botón para cambiar de usuario */}

    <div className="zoneCards">
      <CreditScoreDoughnut score={dataBuro?.cards?.score} />

      <DashboardCard
        title="Obligaciones"
        value={`$${dataBuro?.cards?.obligaciones}`}
        icon={<PiUsersThreeBold />}
        color="#34b9e0"
        data={data}
        showChart={true}
      />
      <DashboardCard
        title="Límite de tarjetas de crédito"
        value={`$${dataBuro?.cards?.limiteTarjetas}`}
        icon={<PiUsersThreeBold />}
        color="#23b56e"
        data={data}
        showChart={true}
      />
      <DashboardCard
        title="Suma de saldos actuales"
        value={`$${dataBuro?.cards?.sumaSaldoActual}`}
        icon={<PiUsersThreeBold />}
        color="#23b56e"
        data={data}
        showChart={true}
      />
      <DashboardCard
        title="Cuentas abiertas"
        value={dataBuro?.cards?.cuentasAbiertas}
        icon={<PiUsersThreeBold />}
        color="#23b56e"
        data={data}
        showChart={true}
      />
      <DashboardCard
        title="Cuantas vencidas"
        value={dataBuro?.cards?.cuentasConSaldoVencido}
        icon={<PiUsersThreeBold />}
        color="#23b56e"
        data={data}
        showChart={true}
      />
    </div>
    <div className="chipsInfo">
      <CustomChips data={dataBuro?.status} />
    </div>
    <div className="tables">
      <DinamycTable data={dataBuro?.domicilios?.data} columns={dataBuro?.domicilios?.configuration} name={dataBuro?.domicilios?.name} />
      <DinamycTable data={dataBuro?.empleos?.data} columns={dataBuro?.empleos?.configuration} name={dataBuro?.empleos?.name} />
      <DinamycTable data={dataBuro?.consultasEfectuadas?.data} columns={dataBuro?.consultasEfectuadas?.configuration} name={dataBuro?.consultasEfectuadas?.name} />
      {/* hawkAlertConsultas se muestra separado en hawkHr y hawkHc */}
      <DinamycTable data={dataBuro?.hawkAlertBd?.data} columns={dataBuro?.hawkAlertBd?.configuration} name={dataBuro?.hawkAlertBd?.name} />
      <DinamycTable data={dataBuro?.declaracionesCliente?.data} columns={dataBuro?.declaracionesCliente?.configuration} name={dataBuro?.declaracionesCliente?.name} />
      <DinamycTable data={dataBuro?.nombresClientes?.data} columns={dataBuro?.nombresClientes?.configuration} name={dataBuro?.nombresClientes?.name} />
      <DinamycTable data={dataBuro?.cuentas?.data} columns={dataBuro?.cuentas?.configuration} name={dataBuro?.cuentas?.name} />
      <SubHeaderRowGroupDemo customerService={dataBuro?.historialPagos[0] ? dataBuro?.historialPagos[0] : []} name={dataBuro?.historialPagos[0]?.name} />
    </div>
  </>
);

// Nuevo componente para PM
const DashboardPM = ({ dataBuro, selectedPerson, setShowUserSelector, people, toast, data }) => (
  <>
    {/* Botón para cambiar de usuario */}

    <div className="zoneCards">

      <CreditScoreDoughnut score={dataBuro?.cards?.score} min={0} max={400} />

      <DashboardCard
        title="Total créditos"
        value={
          <div className="flex flex-column gap-2">
            <div className="text-xl font-bold">Financieros: {dataBuro?.cards?.totalCreditosFinancieros}</div>
            <div className="text-xl font-bold">Comerciales: {dataBuro?.cards?.totalCreditosComerciales}</div>
          </div>
        }
        icon={<PiUsersThreeBold />}
        color="#23b56e"
        data={data}
        showChart={true}
      />
      <DashboardCard
        title="Saldo acumulado quita y quebranto"
        value={`$${dataBuro?.cards?.saldoAcumuladoQuitaQuebranto}`}
        icon={<PiUsersThreeBold />}
        color="#23b56e"
        data={data}
        showChart={true}
      />
      <DashboardCard
        title="Créditos con quita o quebranto"
        value={dataBuro?.cards?.ratioQuitaQuebranto}
        icon={<PiUsersThreeBold />}
        color="#23b56e"
        data={data}
        showChart={true}
      />
      <DashboardCard
        title="Saldo total financiero"
        value={`$${dataBuro?.cards?.saldoTotalFinanciero}`}
        icon={<PiUsersThreeBold />}
        color="#23b56e"
        data={data}
        showChart={true}
      />
      <DashboardCard
        title="Saldo total comercial"
        value={`$${dataBuro?.cards?.saldoTotalComercial}`}
        icon={<PiUsersThreeBold />}
        color="#23b56e"
        data={data}
        showChart={true}
      />
    </div>
    {/* Tablas PM */}
    <div className="tables">
      <DinamycTable data={dataBuro?.datosGenerales?.data} columns={dataBuro?.datosGenerales?.configuration} name={dataBuro?.datosGenerales?.name} />
      <DinamycTable data={dataBuro?.accionistas?.data} columns={dataBuro?.accionistas?.configuration} name={dataBuro?.accionistas?.name} />

      {/*  <DinamycTable data={dataBuro?.creditosFinancieros?.data} columns={dataBuro?.creditosFinancieros?.configuration} name={dataBuro?.creditosFinancieros?.name} /> */}
      <DinamycTable data={dataBuro?.historiaFinanciera?.data} columns={dataBuro?.historiaFinanciera?.configuration} name={dataBuro?.historiaFinanciera?.name} />
      {/*       <DinamycTable data={dataBuro?.hawkAlertConsultas?.data} columns={dataBuro?.hawkAlertConsultas?.configuration} name={dataBuro?.hawkAlertConsultas?.name} />
 */}{/*       <DinamycTable data={dataBuro?.creditosComerciales?.data} columns={dataBuro?.creditosComerciales?.configuration} name={dataBuro?.creditosComerciales?.name} /> */}
      <DinamycTable data={dataBuro?.hawkHr?.data} columns={dataBuro?.hawkHr?.configuration} name={dataBuro?.hawkHr?.name} />
      <DinamycTable data={dataBuro?.hawkHc?.data} columns={dataBuro?.hawkHc?.configuration} name={dataBuro?.hawkHc?.name} />
      <DinamycTable data={dataBuro?.calificaciones?.data} columns={dataBuro?.calificaciones?.configuration} name={dataBuro?.calificaciones?.name} />
      <DinamycTable data={dataBuro?.historialConsultas?.data} columns={dataBuro?.historialConsultas?.configuration} name={dataBuro?.historialConsultas?.name} />
      {/* Créditos Financieros Liquidados */}
      {dataBuro?.historialPagosFinancierosLiquidados?.length > 0 && (
        <SubHeaderRowGroupDemo
          customerService={dataBuro.historialPagosFinancierosLiquidados}
          name={dataBuro.historialPagosFinancierosLiquidados[0]?.name}
        />
      )}

      {/* Créditos Financieros No Liquidados (Activos) */}
      {dataBuro?.historialPagosFinancierosNoLiquidados?.length > 0 && (
        <SubHeaderRowGroupDemo
          customerService={dataBuro.historialPagosFinancierosNoLiquidados}
          name={dataBuro.historialPagosFinancierosNoLiquidados[0]?.name}
        />
      )}

      <hr style={{ border: '1px solid rgb(59, 229, 201)', height: '1px', width: '100%' }} />

      {dataBuro?.historialPagosComercial?.length > 0 && (
        <SubHeaderRowGroupDemo
          customerService={dataBuro.historialPagosComercial[0]}
          name={dataBuro.historialPagosComercial[0][0]?.name || "yolo"}
        />
      )}
    </div>
  </>
);


export const Dashboard = ({ dataBuro, setDataBuro, setLoading, loading, toast, setSelectedPerson, selectedPerson, people, setPeople, currentUser, buroDataCache }) => {
  const data = [1, 2, 1.5, 3, 2.2, 3.5, 3.2]; // Datos simulados
  const [showUserSelector, setShowUserSelector] = useState(false);
  const { authInfo } = useContext(AuthContext);
  const tipoPersona = selectedPerson?.tipo_persona;


  const [saveUserBuro, setSaveUserBuro] = useState([]);



  useEffect(() => {
    const admin = authInfo?.user?.type_user;
    if (admin !== "1") {
      // Redirigir si no es admin
    }
  }, [authInfo]);


  useEffect(() => {
    const fetchData = async () => {
      // setIsFetching2(true);
      const res = await getAllData(toast, selectedPerson.id, buroDataCache);
      // debugger
      setDataBuro(res);
      setLoading(false);
    };

    /*    const fetchDatausers = async (toast) => {
         const res = await fetchDatausersFun(toast);
         setPeople(res.data);
         setLoading(false);
   
       }; */
    // if (authInfo?.user?.type_user === "1" && Object.keys(dataBuro).length === 0 && selectedPerson != null && people.length != 0){
    //     // Si el usuario es admin y no hay datos, obtener los datos
    //     setLoading(true);
    //     fetchData();
    // }
    /*   if (authInfo?.user?.type_user === "1" && Object.keys(dataBuro).length === 0 && people.length === 0) {
  
        setLoading(true);
        fetchDatausers();
      }
   */

    fetchData();
  }, [authInfo]);


  useEffect(() => {
    if (selectedPerson != null && selectedPerson.id != currentUser.current?.id) {
      const fetchData = async () => {
        setLoading(true);
        try {
          const res = await getAllData(toast, selectedPerson.id, buroDataCache);
          setDataBuro(res);
          currentUser.current = selectedPerson;
        } catch (error) {
          console.error('Error al obtener los datos del buró:', error);
          // Puedes agregar un toast o manejo de error aquí si lo necesitas
        } finally {
          setLoading(false);
        }
      };

      fetchData();
    }
  }, [selectedPerson]);




  if (tipoPersona != dataBuro?.tipo_persona) {
    return <Loader />
  }

  return (

    <div
      css={dashboardCSS()}>
      {/* Modal para seleccionar persona */}
      <Dialog
        header="Seleccionar persona"
        visible={showUserSelector}
        style={{ width: '50vw' }}
        breakpoints={{ '960px': '75vw', '641px': '90vw' }}
        onHide={() => setShowUserSelector(false)}
        draggable={false}
      >
        <SelectedPersonComponent
          selectedPerson={selectedPerson}
          setSelectedPerson={(person) => {
            setSelectedPerson(person);
            setShowUserSelector(false);
          }}
          people={people}
          toast={toast}
        />
      </Dialog>

      {/* Información del Budget */}
      {/*   {dataBuro?.budget && (
        <Card style={{
          margin: 'auto',
          marginBottom: '1.5em',
          backgroundColor: '#f8f9fa',
              backgroundColor: '#ffffff',
              width: '97%',
              margin: "auto",
              position: 'relative',
          }}
        >

          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '1rem 3rem',
          }}>
            <h3 style={{
              fontSize: '1.1rem',
              color: '#495057',
              fontWeight: '600',
            }}>
              Información del Presupuesto
            </h3>
           

          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '0.5rem',
          }}>

            <div style={{
              padding: '0.5rem',
              borderRadius: '4px',
              border: '1px solid #dee2e6',
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem',  }}>
                <strong>Cliente:</strong>
                <span>{dataBuro?.budget?.name}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                <strong>ID:</strong>
                <span>{dataBuro?.budget?.insurance_id}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                <strong>Plazo:</strong>
                <span>{dataBuro?.budget?.term} meses</span>
              </div>
            </div>

            <div style={{
              padding: '0.5rem',
              borderRadius: '4px', border: '1px solid #dee2e6',
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                <strong>Marca:</strong>
                <span>{dataBuro.budget.vehicle.brand}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                <strong>Modelo:</strong>
                <span>{dataBuro.budget.vehicle.model}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                <strong>Año:</strong>
                <span>{dataBuro.budget.vehicle.year}</span>
              </div>
            </div>
            <div style={{
              padding: '0.5rem',
              borderRadius: '4px',
              border: '1px solid #dee2e6',
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                <strong>Tipo:</strong>
                <span>{dataBuro.budget.vehicule_type}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                <strong>Motor:</strong>
                <span>{dataBuro.budget.engine}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                <strong>Placa:</strong>
                <span>{dataBuro.budget.state_plate_id}</span>
              </div>
            </div>
            <div style={{
              padding: '0.5rem',
              borderRadius: '4px',
              border: '1px solid #dee2e6',
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                <strong>Precio:</strong>
                <span>{new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(dataBuro.budget.price)}</span>
              </div>
            </div>
            <div style={{
              gridColumn: '1 / -1',
              padding: '0.5rem',
              borderRadius: '4px',
            }}>
              <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '0.5rem', gap: '2rem' }}>
                <strong>Descripción:</strong>
                <span>{dataBuro.budget.vehicle.description}</span>
              </div>
            </div>
          </div>

        </Card>
      )} */}

      {loading && <Loader />}

      {selectedPerson != null && Object.keys(dataBuro).length > 0 ? (
        tipoPersona === "PF" ? (
          <DashboardPF
            dataBuro={dataBuro}
            selectedPerson={selectedPerson}
            setShowUserSelector={setShowUserSelector}
            people={people}
            toast={toast}
            data={data}
          />
        ) : (
          <DashboardPM
            dataBuro={dataBuro}
            selectedPerson={selectedPerson}
            setShowUserSelector={setShowUserSelector} s
            people={people}
            toast={toast}
            data={data}
          />
        )
      ) : (
        <div className="select-user-container">
          <SelectedPersonComponent selectedPerson={selectedPerson} setSelectedPerson={setSelectedPerson} people={people} toast={toast} />
          <div className="shadowCard"></div>
        </div>
      )}

    </div>
  );
};

